// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3Gkgp","col":"Table_col__3VlTz","fulfillmentStatus":"Table_fulfillmentStatus__wsnmX","emailCol":"Table_emailCol__3xxnE"};